import axios from "axios";

export default {
	getCookie() {
		return axios.get("csrf-cookie");
	},
};